// extracted by mini-css-extract-plugin
module.exports = {"taxBudgetCardTitleStyle":"Empty-module__taxBudgetCardTitleStyle--35HBU","container":"Empty-module__container--3Nqp4"};